import styled from "styled-components";
import Button from "@/components/inputs/button";
import SubscriptionDetailsBody from "@/components/cards/subscriptionDetails/subscriptionDetailsBody";
import SubscriptionDetailsTitle from "@/components/cards/subscriptionDetails/subscriptionDetailsTitle";
import { useDispatch, useSelector } from "react-redux";
import { GET_OFFER, GET_OFFER_TYPE, SET_OFFER_VALUE } from "@/store/slices/offerSlice";
import { GET_USER, GET_USER_ADDRESS } from "@/store/slices/userSlice";
import SubscriptionDetailsValue from "@/components/cards/subscriptionDetails/subscriptionDetailsValue";
import SuccessCard from "@/components/cards/success/successCard";
import themes from "@/styles/themes";

import Events from "@/utils/Events";
import { SET_LOADING, SET_MODAL } from "@/store/slices/appSlice";
import DetailsCard from "@/components/cards/detailsCard";
import React, { useEffect, useState } from "react";
import { GET_ACTIVE_SIGNATURE, GET_PAYMENT_DATA } from "@/store/slices/paymentSlice";
import chartbeatConversionEvent from "@/utils/Chartbeat";
import Apm from "@/utils/Apm";
import { generateCookie } from "@/api/login";
import { scriptConversao } from "@/utils/scriptConversao";
import { useRouter } from "next/router";
import { sendEmail } from "@/api/verification";

const TextParcelamento = styled.div`
  margin: 0 0 2% 4%;
  font-size: 16px;
  color: rgb(37, 117, 232);
`

export default function Sucesso() {

    const oferta = useSelector(GET_OFFER)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const user = useSelector(GET_USER)
    const payment = useSelector(GET_PAYMENT_DATA)
    const activate_signature = useSelector(GET_ACTIVE_SIGNATURE)
    const events = new Events();
    const dispatch = useDispatch()
    const endereco = useSelector(GET_USER_ADDRESS)
    const router = useRouter();

    const referrerURL = (): string => {
        const canal = router.query.canal || '';
        const referer = router.query.referrer_url || '';
        const refererStr = typeof referer === 'string' ? referer : referer[0];

        if (canal === 'PAY') {
            const url = new URL(refererStr);
            url.searchParams.set('origem_venda', 'PAY');
            url.searchParams.set('dataHora', new Date().toISOString());
            return url.toString();
        }

        return 'https://www.estadao.com.br/landing/jornada-leitor/1';
    }

    function regenerateCookie() {
        generateCookie().catch(error => {
            Apm.captureError(`REGENERATE_COOKIE: ${error}`)
        })
    }

    let value_offer = oferta.has_partner == true ? 0 : oferta.valor?.valor || oferta.valor?.original;
    const ecommerce = {
        item_id: oferta.cd_oferta,
        item_name: oferta.name,
        price: oferta.valor?.original || oferta.valor?.valor
    }

    const idPedido = typeof payment.idPedido == 'number' ? payment.idPedido?.toString() : payment.idPedido;

    useEffect(() => {
        chartbeatConversionEvent('trackPaywallComplete', { eventLabel: 'compra_sucesso' })
        events.trigger("resumo_de_pedido_visualizado", { offer_type, idPedido })
        events.trigger("pagamento_sucesso_visualizado", { offer_type })
        events.trigger("SHOW_SUCCESS", { oferta, user, payment })
        scriptConversao()
        events.trigger('purchase', {
            event: 'purchase',
            transaction_id: idPedido,
            value: value_offer,
            ecommerce
        });

        if(activate_signature) {
            sendEmail(user.email, Number(idPedido || 0))
        }

        Apm.addLabels({
            event: 'purchase',
            transaction_id: idPedido ? idPedido : false,
            value: value_offer ? value_offer : false,
            item_id: ecommerce.item_id ? ecommerce.item_id : false,
            item_name: ecommerce.item_name ? ecommerce.item_name : false,
            price: ecommerce.price ? ecommerce.price : false,
            resumo: offer_type ? offer_type : false,
            user: user.id_usuario
        });

        if (payment?.voucher) {
            dispatch(SET_OFFER_VALUE('R$ 0,00'))
        }

        regenerateCookie()

        setTimeout(() => {
            dispatch(SET_LOADING(true))
        }, 200);
        setTimeout(() => {
            dispatch(SET_LOADING(false))
        }, 3000)

    }, [])

    const textoEscadinha = oferta?.escadinha?.[endereco.escritorio || 1000]?.a_partir ?? ''

    const canal = router.query.canal || '';
    const referer = router.query.referrer_url || '';
    const refererStr = typeof referer === 'string' ? referer : referer[0];
    // const isNewsLink = refererStr.includes('estadao.com.br/noticias'); // ajustar esse link de noticia
    if (canal) {
        const now = new Date().toISOString();
        localStorage.setItem('ORIGEM_VENDA', JSON.stringify({ origem_venda: canal, dataHora: now, noticia: refererStr }));
    }

    let legalText = oferta.texto?.legal ?? ''

    if (oferta?.is_escadinha) {
        legalText = legalText.replace('[TEXTOESCADINHA]', `por ${textoEscadinha}`)

    }
    if (legalText.includes('[PRECO]')) {
        legalText = legalText.replace('[PRECO]', oferta.valor?.label ?? '')
    }
    return (
        <SuccessCard style={payment?.voucher ? { borderTop: 'none', marginTop: '35px' } : { borderTop: `1px solid ${themes.grey}` }}>
            {activate_signature ? (
                <>
                    <h1>Agradecemos por escolher o Estadão</h1>
                    <p>Agora você precisa verificar a sua conta. <span style={{ fontWeight: "bold" }}>Cheque a sua caixa de email e clique no botão ”Ativar Assinatura”.</span></p>
                </>
            ) : (
                <>
                    <h1>Agradecemos por escolher o Estadão</h1>
                    <p>Seu acesso ao portal de notícias
                        já está liberado.</p>

                    <a href={referrerURL()} onClick={() => events.trigger("resumo_de_pedido_comece_a_usar", { offer_type, idPedido })}><Button>Comece a usar</Button></a>
                </>
            )}
            <div className={'divider'} />
            <h5>Pedido</h5>
            <SubscriptionDetailsBody>
                <SubscriptionDetailsTitle>Assinatura {oferta?.name}</SubscriptionDetailsTitle>

                {payment.parcela &&
                    <div className="row">
                        <TextParcelamento>
                            {oferta.zterm?.find((item: { value: string | undefined; text: string }) => item.value === payment.parcela)?.text}
                        </TextParcelamento>
                    </div>
                }

                <div className="row">
                    <div className="col-md-3">
                        Total
                    </div>
                    <div className="col-md-9 text--right">
                        <SubscriptionDetailsValue><span><span className="valor">{oferta?.valor?.label}</span> {oferta?.valor?.periodo ? oferta?.valor?.periodo?.replace(/\//g, 'por ') : ''}</span></SubscriptionDetailsValue>
                    </div>
                </div>
            </SubscriptionDetailsBody>
            <DetailsCard style={{ backgroundColor: 'transparent' }}>
                <p className={'text-legal'} dangerouslySetInnerHTML={{ __html: legalText ?? '' }} ></p>
                <p className={'text-access'}>
                    {oferta?.texto?.acesso}
                    <br />
                    <span className={'text-summary'} onClick={() => {
                        dispatch(SET_MODAL({ type: "sumario", show: true, bg: '#828282' }))
                        events.trigger("detalhes_oferta_sumario_do_contrato", { offer_type })
                    }}>Sumário do Contrato</span>
                </p>
            </DetailsCard>


        </SuccessCard>
    )
}
